import { useState } from "react";

type PalletReciprocatingLiftControlsProps = {
  disabled?: boolean;
  initialBottomSideRailInset: number;
  initialLayerCount: number;
  onBottomSideRailInsetChange: (bottomSideRailInset: number) => void;
  onLayerCountChange: (layerCount: number) => void;
};

export function PalletReciprocatingLiftControls({
  disabled = false,
  initialBottomSideRailInset,
  initialLayerCount,
  onBottomSideRailInsetChange,
  onLayerCountChange
}: PalletReciprocatingLiftControlsProps) {
  const [bottomSideRailInsetDraft, setBottomSideRailInsetDraft] = useState(
    String(initialBottomSideRailInset)
  );
  const [layerCountDraft, setLayerCountDraft] = useState(String(initialLayerCount));

  return (
    <div className="pallet-reciprocating-lift-controls">
      <span className="pallet-reciprocating-lift-controls-title">托盘往复式提升机</span>
      <label className="pallet-reciprocating-lift-controls-field">
        <span>底层杆向内偏移</span>
        <span className="pallet-reciprocating-lift-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            min="0"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setBottomSideRailInsetDraft(nextDraft);
              if (Number.isFinite(nextValue) && nextValue >= 0) {
                onBottomSideRailInsetChange(nextValue);
              }
            }}
            step="0.001"
            type="number"
            value={bottomSideRailInsetDraft}
          />
          <span>m</span>
        </span>
      </label>
      <label className="pallet-reciprocating-lift-controls-field">
        <span>层数</span>
        <span className="pallet-reciprocating-lift-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="numeric"
            min="1"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setLayerCountDraft(nextDraft);
              if (Number.isInteger(nextValue) && nextValue > 0) {
                onLayerCountChange(nextValue);
              }
            }}
            step="1"
            type="number"
            value={layerCountDraft}
          />
          <span>层</span>
        </span>
      </label>
      <span className="pallet-reciprocating-lift-controls-note">固定层高 2m</span>
    </div>
  );
}
